exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3ZeDxoI_1Pg9tQFD8AZ2z3{display:inline;overflow:hidden;text-overflow:ellipsis;vertical-align:top}._3fSP4ilIbk0dZZ-I9MElKw{font-weight:600}", ""]);
// Exports
exports.locals = {
	"recipientContent": "_3ZeDxoI_1Pg9tQFD8AZ2z3",
	"groupOrDl": "_3fSP4ilIbk0dZZ-I9MElKw"
};